const config = {
    "APIs": {
        "authenticate": "authenticate/access_token",
        "authenticateExternal": "authenticate/external",
        "logout": "authenticate/logout",
    }
}

export default config;